module.exports = __webpack_public_path__ + "ipetbooking-landing/img/home_deposit.859e8b70.png";